import React from "react";

import { StandardContent } from "@/components/App";
import Loader from "@/components/Loader";

export const LinkLoadingPage = () => {
  return (
    <StandardContent>
      <Loader />
    </StandardContent>
  );
};
